import React from 'react';
import SectionHeader from './SectionHeader';
import './ContentSection.scss';

interface ContentSectionProps {
  id?: string;
  title?: string;
  description?: string;
  children: React.ReactNode;
  className?: string;
}

const ContentSection: React.FC<ContentSectionProps> = ({ id, title, description = "", children, className = '' }) => (
  <section id={id} className={`content-section ${className}`}>
    <div className="content-section-inner">
      {title && <SectionHeader title={title} description={description} />}
      {children}
    </div>
  </section>
);

export default ContentSection;
